module.exports = __webpack_public_path__ + "img/gzh.584e5463.jpg";